import { Form, ConfigProvider, Switch, Input } from 'antd';
import { useTranslation } from 'translations/hooks';

import {
  useProdAndPerfFilters,
  useProdAndPerfFiltersFormName,
} from 'business/production-and-performance/providers/prod-and-perf-filters-provider';

export interface PlanningMobileFiltersProps {}

export const PlanningMobileFilters = ({}: PlanningMobileFiltersProps) => {
  const { t } = useTranslation();
  const formName = useProdAndPerfFiltersFormName();
  const filters = useProdAndPerfFilters();
  const [form] = Form.useForm();

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            inlineItemMarginBottom: 12,
          },
        },
      }}
    >
      <Form layout="inline" form={form} name={formName} initialValues={filters}>
        <Form.Item name="filterType" hidden>
          <Input disabled />
        </Form.Item>

        <Form.Item
          name="withProjection"
          layout="vertical"
          label={t('productionAndPerformance.planning.filters.withProjections')}
        >
          <Switch size="small" />
        </Form.Item>
      </Form>
    </ConfigProvider>
  );
};
